module.exports = __webpack_public_path__ + "img/aboutUs.4897bc84.jpg";